import { Button } from '@/global/components/Button'
import notfoudImg from 'assets/not-found.svg'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const NotFound: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className="flex h-[calc(100vh-4rem)] flex-col items-center justify-center gap-2">
            <img src={notfoudImg} alt="" width="60" />
            <h6 className="text-lg font-semibold">Página não encontrada</h6>
            <span className="text-base font-medium">
                talvez você esteja acessando um recurso inexistente ou não que
                tenha autorização.
            </span>
            <br />
            <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate('/')}
            >
                Voltar para o início
            </Button>
        </div>
    )
}
